// Custom text translations for AWS Amplify Authenticator
export const customTexts = {
  en: {
    'Confirm TOTP Code': 'Enter Authenticator App Code',
    'Code': 'Authenticator Code',
    'Enter your TOTP code': 'Enter the 6-digit code from your authenticator app',
    'Confirming': 'Verifying Code...',
    'Confirm': 'Verify Code',
    'Setup TOTP': 'Setup Authenticator App',
    'Scan QR code': 'Scan this QR code with your authenticator app',
  },
};
